/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { NbThemeService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { OverrideService } from './shared/services/override.service';

@Component({
  selector: 'ngx-app',
  template: `<router-outlet></router-outlet> `,
})
export class AppComponent implements OnInit {

  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    private theme: NbThemeService,
    private translate: TranslateService,
    public override: OverrideService) {
    localStorage.setItem('language', this.override.currentLang === 'en' ? 'en' : 'ar');
    translate.setDefaultLang(this.override.currentLang ?
      this.override.currentLang :
      (this.translate.getBrowserLang() === 'ar' ||
       this.translate.getBrowserLang() === 'en' ? this.translate.getBrowserLang() : 'en'));
    override.setTitle('Beauty Doz');
      this.override.switchLanguage(this.override.currentLang === 'en' ? 'en' : 'ar');
  }

  ngOnInit(): void {
    localStorage.setItem('currentTheme', 'corporate');
    this.theme.changeTheme('corporate');

    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
  }
}
